import * as trendActionTypes from 'js/constants/trendAction-Types';
import axios from 'axios';
import getToken from 'helpers/auth';

const getConfig = () => {
  return {
    headers: { Authorization: 'Bearer ' + getToken() },
  };
};

export const showTrendConsume = (chargeId, start_date) => {
  return async (dispatch) => {
    axios
      .get(
        `https://api.metimur.mx/api/trend/consume/${chargeId}/${start_date}`,
        getConfig()
      )
      .then((response) => {
        dispatch(showTrendConsumeSuccess(response.data.data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showTrendConsumeFailure(error.message));
      });
  };
};

export const showTrendConsumeSuccess = (data) => {
  return {
    type: trendActionTypes.SHOW_TREND_CONSUME_SUCCESS,
    payload: data,
  };
};

export const showTrendConsumeFailure = (error) => ({
  type: trendActionTypes.SHOW_TREND_CONSUME_FAILURE,
  state: { error },
});

export const showTrendDemand = (chargeId, start_date) => {
  return async (dispatch) => {
    axios
      .get(
        `https://api.metimur.mx/api/trend/demand/${chargeId}/${start_date}`,
        getConfig()
      )
      .then((response) => {
        dispatch(showTrendDemandSuccess(response.data.data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showTrendDemandFailure(error.message));
      });
  };
};

export const showTrendDemandSuccess = (data) => {
  return {
    type: trendActionTypes.SHOW_TREND_DEMAND_SUCCESS,
    payload: data,
  };
};

export const showTrendDemandFailure = (error) => ({
  type: trendActionTypes.SHOW_TREND_DEMAND_FAILURE,
  state: { error },
});

export const showTrendLoadFactor = (chargeId, start_date) => {
  return async (dispatch) => {
    axios
      .get(
        `https://api.metimur.mx/api/trend/load_factor/${chargeId}/${start_date}`,
        getConfig()
      )
      .then((response) => {
        dispatch(showTrendLoadFactorSuccess(response.data.data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showTrendLoadFactorFailure(error.message));
      });
  };
};

export const showTrendLoadFactorSuccess = (data) => {
  return {
    type: trendActionTypes.SHOW_TREND_LOAD_FACTOR_SUCCESS,
    payload: data,
  };
};

export const showTrendLoadFactorFailure = (error) => ({
  type: trendActionTypes.SHOW_TREND_LOAD_FACTOR_FAILURE,
  state: { error },
});

export const showTrendCo2 = (chargeId, start_date) => {
  return async (dispatch) => {
    axios
      .get(
        `https://api.metimur.mx/api/trend/co2/${chargeId}/${start_date}`,
        getConfig()
      )
      .then((response) => {
        dispatch(showTrendCo2Success(response.data.data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showTrendCo2Failure(error.message));
      });
  };
};

export const showTrendCo2Success = (data) => {
  return {
    type: trendActionTypes.SHOW_TREND_CO2_SUCCESS,
    payload: data,
  };
};

export const showTrendCo2Failure = (error) => ({
  type: trendActionTypes.SHOW_TREND_CO2_FAILURE,
  state: { error },
});

export const showTrendAverage = (chargeId, start_date) => {
  return async (dispatch) => {
    axios
      .get(
        `https://api.metimur.mx/api/trend/average/${chargeId}/${start_date}`,
        getConfig()
      )
      .then((response) => {
        dispatch(showTrendAverageSuccess(response.data.data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(showTrendAverageFailure(error.message));
      });
  };
};

export const showTrendAverageSuccess = (data) => {
  return {
    type: trendActionTypes.SHOW_TREND_AVERAGE_SUCCESS,
    payload: data,
  };
};

export const showTrendAverageFailure = (error) => ({
  type: trendActionTypes.SHOW_TREND_AVERAGE_FAILURE,
  state: { error },
});
